import { SocketChannel } from '@/services/ws/core/channel'
import { EVENTS_ENUM } from './events'
import { newBonusEvent } from './events/newBonus'
import { fsBonusActivatedEvent } from './events/fsBonusActivated'
import { pauseLimitsEvent } from './events/pauseLimits'
import { userUpdatedEvent } from './events/userUpdated'
import { userModalBalanceEvent } from './events/userModalBalance'

class UserChannel extends SocketChannel {
  constructor() {
    super()
    this.register(EVENTS_ENUM.NEW_BONUS, newBonusEvent)
    this.register(EVENTS_ENUM.FS_BONUS_ACTIVATE, fsBonusActivatedEvent)
    this.register(EVENTS_ENUM.LIMIT_EXCEEDED, pauseLimitsEvent)
    // INFO: Different events, same handler. Maybe PAUSE_LIMIT_EXCEEDED is unused within project
    this.register(EVENTS_ENUM.PAUSE_LIMIT_EXCEEDED, pauseLimitsEvent)
    this.register(EVENTS_ENUM.USER_UPDATED, userUpdatedEvent)
    this.register(EVENTS_ENUM.USER_MODAL, userModalBalanceEvent)
  }
}

export const userChannel = new UserChannel()
